import React, { useState, useEffect } from "react";

// Generic blocking-wait loader: creeping progress bar + rotating status
// messages (same visual language as the DR approval regen overlay).
// variant="inline" fills its container; variant="overlay" covers the nearest
// position: relative parent and blocks interaction underneath.
const RotatingMessageLoader = (props = {}) => {
  const {
    title = "",
    messages = [],
    hint = "",
    variant = "inline",
    className = ""
  } = props || {};

  const [statusIdx, setStatusIdx] = useState(0);

  useEffect(() => {
    if (messages.length > 1) {
      const timer = setInterval(
        () => setStatusIdx(i => (i + 1) % messages.length),
        2500
      );
      return () => clearInterval(timer);
    }
  }, [messages.length]);

  return (
    <div
      className={`rmLoader ${
        variant === "overlay" ? "rmLoaderOverlay" : "rmLoaderInline"
      } ${className}`}
    >
      <div className="rmLoaderBar">
        <div className="rmLoaderBarFill" />
      </div>
      <div className="rmLoaderBody">
        {title && <div className="rmLoaderTitle">{title}</div>}
        {messages.length > 0 && (
          <div key={statusIdx} className="rmLoaderStatus">
            {messages[statusIdx]}
          </div>
        )}
        {hint && <div className="rmLoaderHint">{hint}</div>}
      </div>
    </div>
  );
};

export default RotatingMessageLoader;
export { RotatingMessageLoader };
